<div class="title">Network Events</div>

<!--<app-noitems [typeName]="'timeline events'" [isEmpty]="eventData.length==0 && !isLoading" ></app-noitems>-->
@if (eventData.length === 0 && !isLoading && canReadElasticSearch) {
  <div class="noData" id="NoArea">No Data</div>
}
@if (eventData.length === 0 && !isLoading && !canReadElasticSearch) {
  <div class="noData" id="NoArea">
    No Permissions
  </div>
}

<app-loader [isLoading]="isLoading"></app-loader>

@if (eventData.length > 0 && !isLoading) {
  <div
    class="row"
    id="NetworkTimeline"
    >
    <cdk-virtual-scroll-viewport itemSize="20">
      <div *cdkVirtualFor="let alarm of eventData; let i = index; trackBy: trackByTimestamp">
        <div [ngClass]="{ hidden: !isNewDate(i) }" class="timeline">
          <span class="date">{{ formatDate(alarm['@timestamp']) }}</span>
        </div>
        <div class="timeline item">
          <div class="clock icon-Icon_Alarm"></div>
          <div class="connector"></div>
          {{ formatTime(alarm['@timestamp']) }}&nbsp;
          <!-- legacy vtc offline event -->
          @if (alarm['event_type'] === 'router-offline' || alarm['event_type'] === 'sdk-offline' ) {
            <span
              class="bubble severityError"
              style="margin-right: 0rem"
            ></span>
          }
          @if (alarm['event_type'] === 'deleted' ) {
            <span class="bubble v7Offline" style="margin-right: 0rem"></span>
          }
          @if (alarm['event_type'] === 'router-online' || alarm['event_type'] === 'created' || alarm['event_type'] === 'sdk-online') {
            <span
              class="bubble severityInfo"
              style="margin-right: 0rem"
            ></span>
          }
          @if (alarm[eventFields.edgeRouterName] !== undefined) {
            <span class="name">
              {{ alarm[eventFields.edgeRouterName] }}
            </span>
          }
          @if (alarm[eventFields.identityName] !== undefined) {
            <span class="name">
              {{ alarm[eventFields.identityName] }}
            </span>
          }
          @if (alarm['identity_name'] !== undefined) {
            <span class="name">
              {{ alarm['identity_name'] }}
            </span>
          }
          <br />
          @if (
            alarm['event_type'] !== undefined &&
            alarm['event_type'] !== 'created' &&
            alarm['event_type'] !== 'deleted' &&
            alarm['event_type'] !== 'sdk-online' &&
            alarm['event_type'] !== 'sdk-offline'
            ) {
            <div
              class="details"
              >
              @if (alarm[eventFields.identityId]) {
                <span>Endpoint:</span>
              }
              @if (alarm[eventFields.edgeRouterId]) {
                <span>Edge Router:</span>
              }
              {{ alarm.event_type }}
            </div>
          }
          @if (alarm['event_type'] === 'created' || alarm['event_type'] === 'sdk-online') {
            <div class="details">
              @if (alarm[eventFields.identityId]) {
                <span>Endpoint:</span>
              }
              @if (alarm[eventFields.edgeRouterId]) {
                <span>Edge Router:</span>
              }
              @if (alarm['namespace'] === 'sdk') {
                <span>SDK:</span>
              }
              Online
            </div>
          }
          @if (alarm['event_type'] === 'deleted' || alarm['event_type'] === 'sdk-offline') {
            <div class="details">
              @if (alarm[eventFields.identityId]) {
                <span>Endpoint:</span>
              }
              @if (alarm[eventFields.edgeRouterId]) {
                <span>Edge Router:</span>
              }
              @if (alarm['namespace'] === 'sdk') {
                <span>SDK:</span>
              }
              Offline
            </div>
          }
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
}
